import * as React from "react";
const SvgFiBrandsZoom = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M10.132 10.093a2.87 2.87 0 0 0-1.984-.79h-.003c-.72 0-1.437.264-1.985.79a2.62 2.62 0 0 0 0 3.814 2.893 2.893 0 0 0 3.973 0 2.62 2.62 0 0 0 0-3.814m-.795 3.051a1.735 1.735 0 0 1-2.383 0 1.57 1.57 0 0 1 0-2.288 1.735 1.735 0 0 1 2.383 0 1.57 1.57 0 0 1 0 2.288"
      clipRule="evenodd"
    />
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M16.031 10.093a2.87 2.87 0 0 0-1.988-.79c-.72 0-1.437.264-1.985.79a2.62 2.62 0 0 0 0 3.814 2.893 2.893 0 0 0 3.973 0 2.62 2.62 0 0 0 0-3.814m-.795 3.051a1.735 1.735 0 0 1-2.383 0 1.57 1.57 0 0 1 0-2.288 1.735 1.735 0 0 1 2.383 0 1.57 1.57 0 0 1 0 2.288M1.124 14.683l.281.013H5.62l-.015-.269c-.037-.444-.364-.768-.829-.796l-.281-.013H1.967l3.37-3.236-.014-.269c-.022-.448-.364-.773-.828-.796l-.281-.013H0l.014.268c.036.44.368.77.828.796l.28.013h2.529l-3.37 3.237.014.27c.028.444.362.766.829.795M20.354 10.92c.096.16.126.338.138.541l.013.27v1.888l.014.27c.028.44.366.767.829.795l.28.013V11.73l.014-.27c.011-.2.041-.384.138-.543.195-.32.556-.536.971-.536.416 0 .78.217.973.54.096.158.125.341.136.54l.014.268v1.888l.014.27c.029.443.364.77.829.795l.283.015v-3.2359999999999998c0-1.19-1.006-2.157-2.247-2.157-.67 0-1.274.282-1.685.73a2.28 2.28 0 0 0-1.686-.73c-.466 0-.899.136-1.258.37-.219-.233-.707-.37-.988-.37v5.393l.28-.013c.47-.03.811-.348.83-.795l.014-.27V11.73l.013-.27c.012-.203.042-.383.137-.542.195-.32.558-.537.972-.537.415.001.777.217.972.54"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFiBrandsZoom;
